import React from "react";
import { StyledRemoveButton } from './RemoveButton.styles';

interface RemoveButtonProps {
    onRemoveClick: any;
}

export const RemoveButton = (props: RemoveButtonProps) => {
    // const [hovered, setHovered] = React.useState(false);
    const [focused, setFocused] = React.useState(false);
    const [active, setActive] = React.useState(false);

    const handleMouseDown = () => { setActive(true); }
    const handleMouseUp = () => {setActive(false); }
    // const handleMouseOver = () => { setHovered(true); }
    // const handleMouseOut = () => { setHovered(false); }
    const handleFocus = () => { setFocused(true); }
    const handleBlur = () => { setFocused(false); }

    return (
        <StyledRemoveButton
            onClick={props.onRemoveClick()}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            // onMouseOver={handleMouseOver}
            // onMouseOut={handleMouseOut}
            onFocus={handleFocus}
            onBlur={handleBlur}
            active={active}
            focused={focused}
        >
            ✖
        </StyledRemoveButton>
    )
}